import store from '@/store'

export const getInstanceName = (val) => {
  let instanceName = val.instanceName
  try {
    const { fieldListMap } = store.state.fieldList
    const { instanceCode } = val
    let { instanceShowName } = fieldListMap[instanceCode] || {}
    if (instanceCode === 'resume_00523') instanceShowName = fieldListMap.resume_00522?.instanceShowName

    instanceName = instanceShowName || '--'
  } catch (err) {
    instanceName = val.instanceName || ''
  }
  return instanceName
}

// 按钮权限判断
export const hasPermission = (val) => {
  let hasPermission = false
  try {
    const { buttonListMap } = store.state.app
    hasPermission = buttonListMap[val]
  } catch (err) {
    hasPermission = false
  }
  return hasPermission
}

//  判断显示权限
export const isNoShowPermission = (val) => {
  if (!val) return false
  const { fieldLimitListMap } = store.state.fieldList
  const { instanceCode } = val
  const { componentFieldPermissionDto } = fieldLimitListMap[instanceCode] || {}
  // 不可见
  if (componentFieldPermissionDto && (!componentFieldPermissionDto.use || (componentFieldPermissionDto.operate && componentFieldPermissionDto.operat === 3))) return true
  return false
}

//  判断disabled权限
export const isDisabledPermission = (val) => {
  if (!val) return false
  const { fieldLimitListMap } = store.state.fieldList
  const { instanceCode } = val
  const { componentFieldPermissionDto } = fieldLimitListMap[instanceCode] || {}
  // 只读
  if (componentFieldPermissionDto && (!componentFieldPermissionDto.editCan || (componentFieldPermissionDto.operate && componentFieldPermissionDto.operat === 2))) return true
  return false
}

// 判断必填权限
export const isRequiredPermission = (val) => {
  if (!val) return false
  const { fieldLimitListMap } = store.state.fieldList
  const { instanceCode } = val
  const { componentFieldPermissionDto } = fieldLimitListMap[instanceCode] || {}
  // 只读
  if (componentFieldPermissionDto && componentFieldPermissionDto.required) return true
  return false
}
